'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var _colmo = require('../../mixins/colmo');

var _colmo2 = _interopRequireDefault(_colmo);

var _dofIconfont = require('../dof-iconfont');

var _dofIconfont2 = _interopRequireDefault(_dofIconfont);

var _icon = require('./icon');

var _icon2 = _interopRequireDefault(_icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  mixins: [_colmo2.default],
  components: { DofIconfont: _dofIconfont2.default },
  props: {
    //
    value: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'text'
    },
    autofocus: {
      type: Boolean,
      default: false
    },
    maxlength: {
      type: Number
    },
    returnKeyType: {
      type: String
    },
    singleline: {
      type: Boolean,
      default: true
    },
    max: {
      type: String
    },
    min: {
      type: String
    },
    upriseOffset: {
      type: Number
    },
    hideDoneButton: {
      type: Boolean,
      default: false
    },
    bgColor: {
      type: String,
      default: ''
    },
    height: {
      type: Number,
      default: 0
    },
    // 是否展示右侧X
    isShowClear: {
      type: Boolean,
      default: false
    },
    // 是否展示右侧密码切换图标
    isShowPWDIcon: {
      type: Boolean,
      default: false
    },
    // { code: '\u4729', size: 48, color: '#333'}
    icon: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    inputStyle: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    inputBoxStyle: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    // 增加边框弧度参数，设置内容器弧度，解决安卓边框渲染问题
    borderRadius: {
      type: String,
      default: ''
    }
  },
  model: {
    prop: 'value',
    event: 'input'
  },
  watch: {
    type: {
      handler: function handler(val) {
        this.type_ = val;
      },

      immediate: true
    }
  },
  computed: {
    _height: function _height() {
      return this.height ? this.height : this._isColmo ? '104' : '104';
    },
    _inputStyle: function _inputStyle() {
      return _extends({
        backgroundColor: this.bgColor ? this.bgColor : this._isColmo ? '#303237' : '#fff',
        height: this._height + 'px',
        lineHeight: this._height + 'px'
      }, this.inputStyle);
    },
    _inputBoxStyle: function _inputBoxStyle() {
      return _extends({
        height: Number(this._height) + 2 + 'px',
        borderRadius: this.borderRadius
      }, this.inputBoxStyle);
    },
    _isShowClear: function _isShowClear() {
      return this.isShowClear && this.value.length > 0;
    },
    isShowRight: function isShowRight() {
      return this._isShowClear || this.isShowPWDIcon || !!this.$slots.right;
    },
    PWDIcon: function PWDIcon() {
      return this.type_ === 'password' ? '\u4769' : '\u4768';
    },
    PWDImg: function PWDImg() {
      return this.type_ === 'password' ? this.iconImg.show : this.iconImg.hide;
    }
  },
  data: function data() {
    return {
      type_: 'text',
      iconCode: '',
      iconImg: _icon2.default
    };
  },

  methods: {
    input: function input(_ref) {
      var value = _ref.value;

      this.$emit('input', value);
    },
    handleClear: function handleClear() {
      this.$emit('input', '');
    },
    handleClick: function handleClick() {
      this.$emit('iconClick');
    },
    handleTogglePWD: function handleTogglePWD() {
      if (this.type !== 'password' && this.type !== 'text') return;

      if (this.type_ === 'password') {
        this.type_ = 'text';
      } else {
        this.type_ = 'password';
      }
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/script-loader.js!./~/babel-loader/lib!./~/weex-vue-loader/lib/selector.js?type=script&index=0!./packages/dof-input/index.vue
// module id = 339
// module chunks = 0 1